function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { retentionOrderListApi, retentionOrderExcelApi } from '@/api/order';
import { productDetailApi } from '@/api/activity';
import { systemFormDetailApi } from '@/api/systemForm';
import pagesHeader from '@/components/base/pagesHeader';
import detailsFrom from './components/orderDetail';
import { checkPermi } from '@/utils/permission';
import * as $constants from '@/utils/constants';
var defaultTableFrom = {
  status: 'all',
  dateLimit: '',
  orderNo: '',
  page: 1,
  limit: $constants.page.limit[0],
  merchantType: '',
  type: '',
  productId: '',
  searchType: 'all',
  content: ''
};
var getRouteProductFilter = function getRouteProductFilter() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var productId = Number(query.productId);
  if (!query.productId || Number.isNaN(productId) || productId <= 0) {
    return {
      productId: '',
      productName: ''
    };
  }
  return {
    productId: productId,
    productName: query.productName || ''
  };
};
export default {
  name: 'RetentionOrderList',
  components: {
    pagesHeader: pagesHeader,
    detailsFrom: detailsFrom
  },
  computed: {
    showActivityHeader: function showActivityHeader() {
      return this.$route.meta && this.$route.meta.activeMenu === '/activity-product/list';
    },
    hasDynamicFormColumns: function hasDynamicFormColumns() {
      return this.showActivityHeader && this.systemFormColumns.length > 0;
    },
    activityHeaderTitle: function activityHeaderTitle() {
      if (this.currentProductName) return this.currentProductName;
      if (this.tableFrom.productId) return '活动ID：' + this.tableFrom.productId;
      return '活动留资订单';
    }
  },
  data: function data() {
    return {
      tableData: {
        data: [],
        total: 0
      },
      listLoading: false,
      tableFrom: Object.assign({}, defaultTableFrom),
      timeVal: [],
      orderNo: '',
      currentProductName: '',
      systemFormColumns: [],
      systemFormRequestId: 0,
      exportLoading: false,
      statusOptions: [{
        value: 'all',
        label: '全部'
      }, {
        value: 'unPaid',
        label: '未支付'
      }, {
        value: 'notShipped',
        label: '未发货'
      }, {
        value: 'spike',
        label: '待收货'
      }, {
        value: 'awaitVerification',
        label: '待核销'
      }, {
        value: 'receiving',
        label: '已收货'
      }, {
        value: 'complete',
        label: '已完成'
      }, {
        value: 'refunded',
        label: '已退款'
      }, {
        value: 'cancel',
        label: '已取消'
      }, {
        value: 'deleted',
        label: '已删除'
      }],
      merchantTypeOptions: [{
        value: 1,
        label: '电商商户'
      }, {
        value: 10,
        label: '酒店商户'
      }, {
        value: 20,
        label: '餐饮商户'
      }, {
        value: 30,
        label: '门票商户'
      }, {
        value: 40,
        label: '活动供应商'
      }, {
        value: 100,
        label: '景点'
      }]
    };
  },
  mounted: function mounted() {
    this.syncRouteProductFilter(false);
    this.getList();
  },
  watch: {
    '$route.query': {
      handler: function handler() {
        this.syncRouteProductFilter();
      },
      deep: true
    }
  },
  methods: {
    checkPermi: checkPermi,
    formatOrderStatus: function formatOrderStatus(row) {
      if (row.isFreeActivityReservation && row.reservationStatus) {
        var status = {
          WAITING: '待核销',
          PARTIAL: '待核销',
          CANCELLED: '已取消',
          VERIFIED: '已核销',
          COMPLETED_MIXED: '已完成'
        };
        return status[row.reservationStatus] || '-';
      }
      if (Number(row.refundStatus) === 3) return '已退款';
      var filter = this.$options.filters && this.$options.filters.orderStatusFilter || function (value) {
        return value;
      };
      return filter(Number(row.status)) || '-';
    },
    formatFreeActivitySummary: function formatFreeActivitySummary(row) {
      if (!row.isFreeActivityReservation) return '-';
      return '总 ' + Number(row.totalNum || 0) + ' · 已核销 ' + Number(row.verifiedNum || 0) + ' · 已取消 ' + Number(row.cancelledNum || 0) + ' · 剩余 ' + Number(row.remainingNum || 0);
    },
    getSystemFormFieldLabel: function getSystemFormFieldLabel(field, index) {
      if (field && field.titleConfig && field.titleConfig.val) {
        return String(field.titleConfig.val).trim();
      }
      return "\u5B57\u6BB5".concat(index + 1);
    },
    normalizeRetentionTitle: function normalizeRetentionTitle(title) {
      return String(title || '').replace(/（必填）/g, '').replace(/[：:]\s*$/g, '').trim();
    },
    buildSystemFormColumns: function buildSystemFormColumns(formValue) {
      var _this = this;
      if (!formValue) return [];
      var parsed = {};
      try {
        parsed = typeof formValue === 'string' ? JSON.parse(formValue) : formValue;
      } catch (error) {
        return [];
      }
      return Object.keys(parsed).sort().map(function (key) {
        return parsed[key];
      }).sort(function (a, b) {
        return (a.timestamp || 0) - (b.timestamp || 0);
      }).map(function (field, index) {
        var label = _this.getSystemFormFieldLabel(field, index);
        return {
          key: "".concat(field.timestamp || index, "-").concat(field.name || 'field'),
          label: label,
          normalizedLabel: _this.normalizeRetentionTitle(label)
        };
      }).filter(function (column, index, list) {
        return list.findIndex(function (item) {
          return item.normalizedLabel === column.normalizedLabel;
        }) === index;
      });
    },
    stringifyRetentionValue: function stringifyRetentionValue(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      if (Array.isArray(value)) {
        var items = value.map(function (item) {
          return String(item || '').trim();
        }).filter(function (item) {
          return item;
        });
        return items.length ? items.join(' / ') : '-';
      }
      if (_typeof(value) === 'object') {
        return JSON.stringify(value);
      }
      return String(value);
    },
    formatExportDateTime: function formatExportDateTime(value) {
      var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!value) return '-';
      if (typeof value === 'string') {
        if (!includeTime && value.length >= 10) return value.slice(0, 10);
        return value;
      }
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      if (!includeTime) return "".concat(year, "-").concat(month, "-").concat(day);
      var hour = String(date.getHours()).padStart(2, '0');
      var minute = String(date.getMinutes()).padStart(2, '0');
      var second = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minute, ":").concat(second);
    },
    formatPayType: function formatPayType(payType, payChannel) {
      var filter = this.$options.filters && this.$options.filters.payTypeFilter || function (value) {
        return value;
      };
      return filter(payType, payChannel) || payType || payChannel || '-';
    },
    buildRetentionValueMap: function buildRetentionValueMap(orderExtend) {
      var _this2 = this;
      if (!orderExtend) return {};
      var parsed = [];
      try {
        parsed = typeof orderExtend === 'string' ? JSON.parse(orderExtend) : orderExtend;
      } catch (error) {
        return {};
      }
      if (!Array.isArray(parsed)) return {};
      return parsed.reduce(function (map, item, index) {
        var rawTitle = item && item.title ? String(item.title).trim() : "\u5B57\u6BB5".concat(index + 1);
        var normalizedTitle = _this2.normalizeRetentionTitle(rawTitle);
        var value = _this2.stringifyRetentionValue(item ? item.value : '');
        if (rawTitle && map[rawTitle] === undefined) {
          map[rawTitle] = value;
        }
        if (normalizedTitle && map[normalizedTitle] === undefined) {
          map[normalizedTitle] = value;
        }
        return map;
      }, {});
    },
    decorateRetentionRows: function decorateRetentionRows() {
      var _this3 = this;
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return list.map(function (row) {
        return Object.assign({}, row, {
          retentionValueMap: _this3.buildRetentionValueMap(row.orderExtend)
        });
      });
    },
    getDynamicColumnValue: function getDynamicColumnValue(row, column) {
      var valueMap = row.retentionValueMap || {};
      return valueMap[column.normalizedLabel] || valueMap[column.label] || '-';
    },
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      var routeFilter = getRouteProductFilter(this.$route.query);
      this.tableFrom = Object.assign({}, defaultTableFrom, {
        productId: routeFilter.productId
      });
      this.currentProductName = routeFilter.productName;
      this.timeVal = [];
      this.loadActivitySystemForm(routeFilter.productId);
      this.getList();
    },
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e || [];
      this.tableFrom.dateLimit = e ? e.join(',') : '';
      this.handleSearchList();
    },
    getList: function getList() {
      var _this4 = this;
      this.listLoading = true;
      return retentionOrderListApi(this.tableFrom).then(function (res) {
        _this4.tableData.data = _this4.decorateRetentionRows(res.list || []);
        _this4.tableData.total = res.total || 0;
      }).finally(function () {
        _this4.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    fetchRetentionExportRows: function () {
      var _fetchRetentionExportRows = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var limit, page, total, rows, res, currentRows;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              limit = 200;
              page = 1;
              total = 0;
              rows = [];
            case 1:
              _context.n = 2;
              return retentionOrderListApi(_objectSpread(_objectSpread({}, this.tableFrom), {}, {
                page: page,
                limit: limit
              }));
            case 2:
              res = _context.v;
              currentRows = this.decorateRetentionRows(res.list || []);
              rows = rows.concat(currentRows);
              total = Number(res.total || 0);
              page += 1;
            case 3:
              if (rows.length < total) {
                _context.n = 1;
                break;
              }
            case 4:
              return _context.a(2, rows);
          }
        }, _callee, this);
      }));
      function fetchRetentionExportRows() {
        return _fetchRetentionExportRows.apply(this, arguments);
      }
      return fetchRetentionExportRows;
    }(),
    exportActivityRetentionOrders: function () {
      var _exportActivityRetentionOrders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this5 = this;
        var rows, _yield$import, export_json_to_excel, dynamicHeaders, header, columnCount, multiHeader, merges, data, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.exportLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return this.fetchRetentionExportRows();
            case 2:
              rows = _context2.v;
              if (rows.length) {
                _context2.n = 3;
                break;
              }
              this.$message.warning('没有可导出的数据');
              return _context2.a(2);
            case 3:
              _context2.n = 4;
              return import('@/vendor/Export2Excel');
            case 4:
              _yield$import = _context2.v;
              export_json_to_excel = _yield$import.export_json_to_excel;
              dynamicHeaders = this.systemFormColumns.map(function (column) {
                return column.label;
              });
              header = ['订单号', '用户昵称', '业务类型', '实际支付金额', '消费券金额', '订单金额', '支付方式', '订单状态', '预约日期', '商品信息'].concat(_toConsumableArray(dynamicHeaders), ['下单时间']);
              columnCount = header.length;
              multiHeader = [['留资订单导出'].concat(_toConsumableArray(new Array(columnCount - 1).fill(''))), ["\u751F\u6210\u65F6\u95F4:".concat(this.formatExportDateTime(new Date()))].concat(_toConsumableArray(new Array(columnCount - 1).fill('')))];
              merges = ["A1:".concat(this.getExcelColumnName(columnCount), "1"), "A2:".concat(this.getExcelColumnName(columnCount), "2")];
              data = rows.map(function (row) {
                return [row.orderNo || '-', row.nickName || '-', row.merchantTypeName || '-', row.payPrice || '0', row.couponPrice || '0', row.totalPrice || '0', _this5.formatPayType(row.payType, row.payChannel), _this5.formatOrderStatus(row), _this5.formatExportDateTime(row.activityReservationDate, true), row.productInfo || '-'].concat(_toConsumableArray(_this5.systemFormColumns.map(function (column) {
                  return _this5.getDynamicColumnValue(row, column);
                })), [_this5.formatExportDateTime(row.createTime, true)]);
              });
              export_json_to_excel({
                multiHeader: multiHeader,
                header: header,
                data: data,
                merges: merges,
                filename: '留资订单导出',
                autoWidth: true
              });
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t = _context2.v;
              this.$message.error('导出失败，请稍后重试');
            case 6:
              _context2.p = 6;
              this.exportLoading = false;
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 5, 6, 7]]);
      }));
      function exportActivityRetentionOrders() {
        return _exportActivityRetentionOrders.apply(this, arguments);
      }
      return exportActivityRetentionOrders;
    }(),
    getExcelColumnName: function getExcelColumnName(index) {
      var result = '';
      var current = index;
      while (current > 0) {
        var remainder = (current - 1) % 26;
        result = String.fromCharCode(65 + remainder) + result;
        current = Math.floor((current - 1) / 26);
      }
      return result;
    },
    exports: function exports() {
      var _this6 = this;
      if (this.hasDynamicFormColumns) {
        this.exportActivityRetentionOrders();
        return;
      }
      this.exportLoading = true;
      var params = {
        dateLimit: this.tableFrom.dateLimit,
        orderNo: this.tableFrom.orderNo,
        status: this.tableFrom.status,
        merchantType: this.tableFrom.merchantType,
        type: this.tableFrom.type,
        productId: this.tableFrom.productId,
        searchType: this.tableFrom.searchType,
        content: this.tableFrom.content
      };
      retentionOrderExcelApi(params).then(function (res) {
        var baseUrl = process.env.VUE_APP_BASE_API.replace(/\/api$/, '');
        var fileName = res.fileName.startsWith('/') ? res.fileName : '/' + res.fileName;
        window.open(baseUrl + fileName);
      }).catch(function () {
        _this6.$message.error('导出失败，请稍后重试');
      }).finally(function () {
        _this6.exportLoading = false;
      });
    },
    onOrderDetails: function onOrderDetails(orderNo) {
      this.orderNo = orderNo;
      this.$refs.orderDetail.getDetail(orderNo);
      this.$refs.orderDetail.getOrderInvoiceList(orderNo);
      this.$refs.orderDetail.dialogVisible = true;
    },
    loadActivitySystemForm: function () {
      var _loadActivitySystemForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(productId) {
        var currentRequestId, product, columns, form, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              currentRequestId = this.systemFormRequestId + 1;
              this.systemFormRequestId = currentRequestId;
              if (productId) {
                _context3.n = 1;
                break;
              }
              this.systemFormColumns = [];
              return _context3.a(2);
            case 1:
              _context3.p = 1;
              _context3.n = 2;
              return productDetailApi(productId);
            case 2:
              product = _context3.v;
              if (!(currentRequestId !== this.systemFormRequestId)) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              if (product && product.name) {
                this.currentProductName = product.name;
              }
              columns = this.buildSystemFormColumns(product && product.systemFormValue);
              if (!(!columns.length && product && product.systemFormId)) {
                _context3.n = 6;
                break;
              }
              _context3.n = 4;
              return systemFormDetailApi(product.systemFormId);
            case 4:
              form = _context3.v;
              if (!(currentRequestId !== this.systemFormRequestId)) {
                _context3.n = 5;
                break;
              }
              return _context3.a(2);
            case 5:
              columns = this.buildSystemFormColumns(form && form.formValue);
            case 6:
              this.systemFormColumns = columns;
              _context3.n = 9;
              break;
            case 7:
              _context3.p = 7;
              _t2 = _context3.v;
              if (!(currentRequestId !== this.systemFormRequestId)) {
                _context3.n = 8;
                break;
              }
              return _context3.a(2);
            case 8:
              this.systemFormColumns = [];
            case 9:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 7]]);
      }));
      function loadActivitySystemForm(_x) {
        return _loadActivitySystemForm.apply(this, arguments);
      }
      return loadActivitySystemForm;
    }(),
    syncRouteProductFilter: function syncRouteProductFilter() {
      var shouldReload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var routeFilter = getRouteProductFilter(this.$route.query);
      var hasChanged = this.tableFrom.productId !== routeFilter.productId || this.currentProductName !== routeFilter.productName;
      this.tableFrom.productId = routeFilter.productId;
      this.currentProductName = routeFilter.productName;
      if (hasChanged) {
        this.loadActivitySystemForm(routeFilter.productId);
      }
      if (shouldReload && hasChanged) {
        this.tableFrom.page = 1;
        this.getList();
      }
    }
  }
};